function addOptionsToDropdown(selector, options, selectedValue) {
  $.each(options, function (value, name) {
    var option = $('<option/>').attr('value', value).text(name);

    if (value === selectedValue) {
      option.attr('selected', 'selected');
    }

    $(selector).append(option);
  });
}

function preselectPaymentType(paymentTypes, transactionType) {
  var selectedType = Object.keys(paymentTypes)[0];
  addOptionsToDropdown("#".concat(transactionType, "_transaction_payment_type"), paymentTypes, selectedType);
  $('.payment-type').addClass('hidden');
}

function updatePaymentTypes(paymentTypes, transactionType) {
  var selectedType = $("#".concat(transactionType, "_transaction_payment_type option:selected")).val();
  var emptyValue = '<option value="">' + I18n.t('javascript.options.please_select') + '</option>';

  if (selectedType === '' || selectedType === undefined) {
    selectedType = transactionType;
  }

  $("#".concat(transactionType, "_transaction_payment_type")).empty();
  $("#".concat(transactionType, "_transaction_payment_type")).append(emptyValue);

  if (Object.keys(paymentTypes).length === 0) {
    $('.payment-type').addClass('hidden');
  } else if (Object.keys(paymentTypes).length === 1) {
    preselectPaymentType(paymentTypes, transactionType);
  } else {
    addOptionsToDropdown("#".concat(transactionType, "_transaction_payment_type"), paymentTypes, selectedType);
    $('.payment-type').removeClass('hidden');
    $('.for_chosen').trigger('chosen:updated');
  }
}

export { updatePaymentTypes, addOptionsToDropdown };